import BannerSlide from './BannerSlide';
import { Sliderdata } from '../assets/Data/Storedata';
import React from 'react';  
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const Herobanner = () => {
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 600,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        className : "slides"
      };

  return (
    <div className='w-full mb-8'>
        <Slider {...settings}>
            {Sliderdata.map((item) => {
                return(
                    <BannerSlide key={item.id} text={item.text} imgurl={item.imgurl}/>
                );
            })}
            </Slider>
    </div>
  )
}

export default Herobanner;